module.exports = __webpack_public_path__ + "static/media/7.543c19d8.svg";